// External Dependencies:
import React from 'react'
import { connect } from 'react-redux'

// Internal Dependencies:
import PageSectionEditorUI from './_PageSectionEditorUI'
import PasswordProtected from './_PasswordProtected'

// import TextImageColumns from './TextImageColumns'
import Columns from './Columns'
import Heading from './Heading'
import Columns2TextMedia from './Columns2TextMedia'
// import Columns2HeadingText from './Columns2HeadingText'
import MediaSection from './MediaSection'
import Hero from './Hero'
import { get, loop } from 'utilities/objects'

class PageSections extends React.Component {
	renderContent() {
		const page = this.props.pageOverride ? this.props.pageOverride : this.props.page

		if ( ! page ) {
			return null
		}

		let itemsMarkup = [],
			evenOdd = 'even',
			previousEvenOdd = 'even',
			previousType = '',
			previousBg = '',
			sectionStyle = {},

			doingWrap = false,
			finishedWrap = false,
			wrapInnerMarkup = [],
			wrapNumberToGo = 0,
			wrapStyle = {},
			customStyles = ''

		loop( page.page_sections, ( key, item ) => {
			let component = null,
				sectionStyle = {},
				extraWrapClass = '',
				sectionHtmlId = `section-${key}`

			// Carry across previous bg, unless overwritten (later):
			if ( previousBg ) {
				sectionStyle.background = previousBg
			}

			// Switch even/odd:
			previousEvenOdd = evenOdd
			evenOdd = 'even' == evenOdd ? 'odd' : 'even'

			// Check for cases when even/odd should not swtich:
			if (
				'columns_2_heading_text' == previousType && 'columns_2_heading_text' == item.type ||
				'columns_2_text_media' == previousType && 'columns_2_text_media' == item.type
			) {
				evenOdd = previousEvenOdd
			}

			// Extra settings:
			const zIndex = get( ['settings', 'z_index'] )( item, false )

			if ( zIndex ) {
				sectionStyle.zIndex = zIndex
			}

			// Check for wraps:
			const bg = get( ['settings', 'bg'] )( item, '' )
			const extendBg = get( ['settings', 'extend_bg'] )( item, '' )
			const extendBgSectionsNumber = parseInt( get( ['settings', 'extend_bg_sections_number'] )( item, 1 ), 10 )

			// Determine how many sections left to add to the wrap:
			if ( doingWrap ) {
				wrapNumberToGo--

				if ( ! wrapNumberToGo ) {
					finishedWrap = true
				}
			}

			// Check if wrap should start:
			if ( ! doingWrap && extendBg ) {
				doingWrap = true
				finishedWrap = false
				wrapNumberToGo = extendBgSectionsNumber
				wrapStyle = {
					background: bg
				}
			}

			if ( ! doingWrap && bg ) {
				sectionStyle.background = bg
				previousBg = bg
			}

			// Check type:
			previousType = item.type

			switch ( item.type ) {
				case 'heading':
					component = <Heading contentId="page_sections" sectionId={ key } data={ item } />
					break

				case 'columns':
					component = <Columns contentId="page_sections" sectionId={ key } data={ item } />
					let columnsClass = get( ['settings', 'class'] )( item, '' )

					// Padding top:
					let columnsPaddingTop = get( ['settings', 'padding_top'] )( item, '' )
					let columnsPaddingTopCustom = get( ['settings', 'padding_top_custom'] )( item, '' )

					let columnsDesktopPaddingTop = get( ['settings', 'desktop_padding_top'] )( item, '' )
					let columnsDesktopPaddingTopCustom = get( ['settings', 'desktop_padding_top_custom'] )( item, '' )

					let columnsTabletPaddingTop = get( ['settings', 'tablet_padding_top'] )( item, '' )
					let columnsTabletPaddingTopCustom = get( ['settings', 'tablet_padding_top_custom'] )( item, '' )

					let columnsMobilePaddingTop = get( ['settings', 'mobile_padding_top'] )( item, '' )
					let columnsMobilePaddingTopCustom = get( ['settings', 'mobile_padding_top_custom'] )( item, '' )

					// Padding bottom:
					let columnsPaddingBottom = get( ['settings', 'padding_bottom'] )( item, '' )
					let columnsPaddingBottomCustom = get( ['settings', 'padding_bottom_custom'] )( item, '' )

					let columnsDesktopPaddingBottom = get( ['settings', 'desktop_padding_bottom'] )( item, '' )
					let columnsDesktopPaddingBottomCustom = get( ['settings', 'desktop_padding_bottom_custom'] )( item, '' )

					let columnsTabletPaddingBottom = get( ['settings', 'tablet_padding_bottom'] )( item, '' )
					let columnsTabletPaddingBottomCustom = get( ['settings', 'tablet_padding_bottom_custom'] )( item, '' )

					let columnsMobilePaddingBottom = get( ['settings', 'mobile_padding_bottom'] )( item, '' )
					let columnsMobilePaddingBottomCustom = get( ['settings', 'mobile_padding_bottom_custom'] )( item, '' )

					if ( columnsClass ) {
						extraWrapClass +=  ` ${columnsClass}-wrap`
					}

					// Padding top:
					if ( columnsPaddingTop ) {
						extraWrapClass +=  ` -padding-top-${columnsPaddingTop}-wrap`
					}
					if ( columnsPaddingTopCustom ) {
						customStyles += `#${sectionHtmlId} {padding-top: ${columnsPaddingTopCustom}px}`
					}

					if ( columnsDesktopPaddingTop ) {
						extraWrapClass +=  ` -desktop-padding-top-${columnsDesktopPaddingTop}-wrap`
					}
					if ( columnsDesktopPaddingTopCustom ) {
						customStyles += `.breakpoint-large-min #${sectionHtmlId} {padding-top: ${columnsDesktopPaddingTopCustom}px}`
					}

					if ( columnsTabletPaddingTop ) {
						extraWrapClass +=  ` -tablet-padding-top-${columnsTabletPaddingTop}-wrap`
					}
					if ( columnsTabletPaddingTopCustom ) {
						customStyles += `.breakpoint-medium #${sectionHtmlId} {padding-top: ${columnsTabletPaddingTopCustom}px}`
					}

					if ( columnsMobilePaddingTop ) {
						extraWrapClass +=  ` -mobile-padding-top-${columnsMobilePaddingTop}-wrap`
					}
					if ( columnsMobilePaddingTopCustom ) {
						customStyles += `.breakpoint-small #${sectionHtmlId} {padding-top: ${columnsMobilePaddingTopCustom}px}`
					}

					// Padding bottom:
					if ( columnsPaddingBottom ) {
						extraWrapClass +=  ` -padding-bottom-${columnsPaddingBottom}-wrap`
					}
					if ( columnsPaddingBottomCustom ) {
						customStyles += `#${sectionHtmlId} {padding-bottom: ${columnsPaddingBottomCustom}px}`
					}

					if ( columnsDesktopPaddingBottom ) {
						extraWrapClass +=  ` -desktop-padding-bottom-${columnsDesktopPaddingBottom}-wrap`
					}
					if ( columnsDesktopPaddingBottomCustom ) {
						customStyles += `.breakpoint-large-min #${sectionHtmlId} {padding-bottom: ${columnsDesktopPaddingBottomCustom}px}`
					}

					if ( columnsTabletPaddingBottom ) {
						extraWrapClass +=  ` -tablet-padding-bottom-${columnsTabletPaddingBottom}-wrap`
					}
					if ( columnsTabletPaddingBottomCustom ) {
						customStyles += `.breakpoint-medium #${sectionHtmlId} {padding-bottom: ${columnsTabletPaddingBottomCustom}px}`
					}

					if ( columnsMobilePaddingBottom ) {
						extraWrapClass +=  ` -mobile-padding-bottom-${columnsMobilePaddingBottom}-wrap`
					}
					if ( columnsMobilePaddingBottomCustom ) {
						customStyles += `.breakpoint-small #${sectionHtmlId} {padding-bottom: ${columnsMobilePaddingBottomCustom}px}`
					}

					break

				// case 'columns_2_text_media':
				// 	component = <Columns2TextMedia contentId="page_sections" sectionId={ key } data={ item } />
				// 	break

				// case 'columns_2_heading_text':
				// 	component = <Columns2HeadingText contentId="page_sections" sectionId={ key } data={ item } />
				// 	break

				case 'media':
					component = <MediaSection contentId="page_sections" sectionId={ key } data={ item } />
					break

				case 'hero':
					component = <Hero contentId="page_sections" sectionId={ key } data={ item } />
					break
			}

			if ( ! component ) {
				return null
			}

			if ( doingWrap ) {
				// Place inside the wrap:
				wrapInnerMarkup.push(
					<section id={ sectionHtmlId } className={ `page-section page-section-${item.type} is-${evenOdd} ${extraWrapClass}` } key={ key }>
						{ component }

						<PageSectionEditorUI id="page_sections" sectionId={ key } sectionData={ item } prevItemKey={ key } allSections={ page.page_sections } />
					</section>
				)

				if ( finishedWrap ) {
					// Finish the wrap and add the sections:
					itemsMarkup.push(
						<section className={ `page-section page-section-wrap` } key={ `${key}-wrap` } style={ wrapStyle }>
							{ wrapInnerMarkup }
						</section>
					)

					doingWrap = false
					finishedWrap = false
					wrapInnerMarkup = []
					wrapNumberToGo = 0
					wrapStyle = {}
				}
			} else {
				// Add the section:
				itemsMarkup.push(
					<section id={ sectionHtmlId } className={ `page-section page-section-${item.type} is-${evenOdd} ${extraWrapClass}` } key={ key } style={ sectionStyle }>
						{ component }

						<PageSectionEditorUI id="page_sections" sectionId={ key } sectionData={ item } prevItemKey={ key } allSections={ page.page_sections } />
					</section>
				)
			}
		} )

		itemsMarkup = itemsMarkup.filter( Boolean )

		return (
			<div className="page-sections is-editable-page-sections" key={ page.id }>
				{ customStyles &&
					<style dangerouslySetInnerHTML={ { __html: customStyles } } />
				}

				{ itemsMarkup }

				{ ( ! itemsMarkup.length ) &&
					<section className="page-section">
						<div className="page-section-empty"></div>

						<PageSectionEditorUI id="page_sections" />
					</section>
				}
			</div>
		)
	}

	render() {
		const page = this.props.pageOverride ? this.props.pageOverride : this.props.page

		if ( ! page ) {
			return null
		}

		if ( page.is_password_protected ) {
			return (
				<div className="page-sections">
					<section className="page-section page-section-password-protected is-odd">
						<PasswordProtected />
					</section>
				</div>
			)
		} else {
			return this.renderContent()
		}
	}
}

const mapStateToProps = ( state, ownProps ) => {
	return {
		page: state.page.selected
	}
}

export default connect( mapStateToProps )( PageSections )



// WEBPACK FOOTER //
// ./components/PageSections/_PageSections.jsx